import React from "react";
import { ReactComponent as InfoIcon } from "../../../../assets/Icon feather-info.svg";
import Tippy from "@tippyjs/react";
import "./style.css";

const ExtraRequestTooltip = ({
  request_type,
  request_info,
  currency,
  exchange_rate,
}) => {
  return (
    <Tippy
      placement="bottom"
      arrow={true}
      interactive={true}
      content={
        <CustomTooltipContent
          request_type={request_type}
          request_info={request_info}
          currency={currency}
          exchange_rate={exchange_rate}
        />
      }
      offset={[8, 8]}
      // animation="fade"
      className="rd-extra-req-tp"
    >
      <InfoIcon />
    </Tippy>
  );
};

export default ExtraRequestTooltip;

function CustomTooltipContent({
  request_type,
  request_info = [],
  currency = "USD",
  exchange_rate = 1,
}) {
  return (
    <div className="rd-extra-req-tp-body">
      {request_info.map((item, index) => {
        const { price = 0 } = item;

        let price_text = "";

        if (price == 0) {
          price_text = "Free";
        } else {
          price_text = `${currency} ${(price * exchange_rate).toFixed(2)}`;
        }

        return (
          <div className="rd-er-item" key={item.id}>
            <div>
              <span>
                {request_type} {index + 1}:
              </span>{" "}
              {item.room_name}
            </div>
            <div>{price_text}</div>
          </div>
        );
      })}
    </div>
  );
}
